import React, { useState } from 'react';

const CloudSecurity = () => {
  const [monitoring, setMonitoring] = useState(true);

  return (
    <div className="min-h-screen bg-cyber-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white">Cloud Security</h1>
          <p className="text-gray-400 mt-1">Monitor cloud services and shadow IT</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-cyber-card border border-gray-800 rounded-lg p-6">
            <h3 className="text-sm text-gray-400 mb-1">Cloud Apps</h3>
            <p className="text-3xl font-bold text-white">24</p>
          </div>
          <div className="bg-cyber-card border border-gray-800 rounded-lg p-6">
            <h3 className="text-sm text-gray-400 mb-1">Unauthorized</h3>
            <p className="text-3xl font-bold text-red-400">3</p>
          </div>
          <div className="bg-cyber-card border border-gray-800 rounded-lg p-6">
            <h3 className="text-sm text-gray-400 mb-1">Data Transfers</h3>
            <p className="text-3xl font-bold text-white">1.2TB</p>
          </div>
          <div className="bg-cyber-card border border-gray-800 rounded-lg p-6">
            <h3 className="text-sm text-gray-400 mb-1">Risk Score</h3>
            <p className="text-3xl font-bold text-yellow-400">Medium</p>
          </div>
        </div>

        <div className="bg-cyber-card border border-gray-800 rounded-lg p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-semibold text-white">Cloud Monitoring</h3>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={monitoring}
                onChange={(e) => setMonitoring(e.target.checked)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyber-cyan"></div>
            </label>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { name: 'Microsoft 365', users: 145, status: 'Authorized', risk: 'Low' },
              { name: 'Google Workspace', users: 89, status: 'Authorized', risk: 'Low' },
              { name: 'Dropbox', users: 34, status: 'Unauthorized', risk: 'High' },
              { name: 'Slack', users: 178, status: 'Authorized', risk: 'Medium' },
              { name: 'AWS', users: 12, status: 'Authorized', risk: 'Low' },
              { name: 'Unknown Cloud Storage', users: 5, status: 'Unauthorized', risk: 'Critical' },
            ].map((app, index) => (
              <div key={index} className="bg-cyber-darker border border-gray-700 rounded-lg p-4">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h4 className="text-white font-medium">{app.name}</h4>
                    <p className="text-sm text-gray-400">{app.users} active users</p>
                  </div>
                  <span className={`px-2 py-1 text-xs rounded ${
                    app.status === 'Authorized'
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-red-500/20 text-red-400'
                  }`}>
                    {app.status}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400">Risk Level:</span>
                  <span className={`px-2 py-1 text-xs rounded ${
                    app.risk === 'Low'
                      ? 'bg-green-500/20 text-green-400'
                      : app.risk === 'Medium'
                      ? 'bg-yellow-500/20 text-yellow-400'
                      : app.risk === 'High'
                      ? 'bg-orange-500/20 text-orange-400'
                      : 'bg-red-500/20 text-red-400'
                  }`}>
                    {app.risk}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-cyber-card border border-gray-800 rounded-lg p-6">
          <h3 className="text-xl font-semibold text-white mb-4">Shadow IT Alerts</h3>
          <div className="space-y-3">
            {[
              { app: 'Personal Dropbox', user: 'john.doe@company.com', data: '450MB', time: '1 hour ago' },
              { app: 'WeTransfer', user: 'jane.smith@company.com', data: '1.2GB', time: '3 hours ago' },
              { app: 'Unauthorized Cloud Storage', user: 'mike.jones@company.com', data: '2.1GB', time: '1 day ago' },
            ].map((alert, index) => (
              <div key={index} className="bg-cyber-darker border border-gray-700 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-white font-medium">{alert.app}</h4>
                    <p className="text-sm text-gray-400">{alert.user}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-white font-medium">{alert.data}</p>
                    <p className="text-xs text-gray-500">{alert.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudSecurity;